export const LOGS = { ENABLE_LOGS: false};